import { ref } from 'vue'
import { debugConsoleWarn } from '@/modules/chat-matrix-fast/utils/chatDebugLog'

/** Ревизия для реактивного UI mute в списке чатов. */
export const chatNotificationsRevision = ref(0)

const STORAGE_KEY_PREFIX = 'chat-notifications-'

function getStorageKey(chatId: number | string): string {
  return `${STORAGE_KEY_PREFIX}${chatId}`
}

export function getChatNotificationsEnabled(chatId: number | string | null | undefined): boolean {
  if (!chatId) return true

  try {
    const key = getStorageKey(chatId)
    const value = localStorage.getItem(key)

    if (value === null) return true

    return JSON.parse(value) === true
  } catch (error) {
    debugConsoleWarn('Ошибка при чтении настроек уведомлений чата:', error)
    return true
  }
}

export function setChatNotificationsEnabled(chatId: number | string | null | undefined, enabled: boolean): void {
  if (!chatId) return

  try {
    const key = getStorageKey(chatId)
    localStorage.setItem(key, JSON.stringify(enabled))
    chatNotificationsRevision.value++
  } catch (error) {
    debugConsoleWarn('Ошибка при сохранении настроек уведомлений чата:', error)
  }
}
